module.exports = __webpack_public_path__ + "static/media/Ensaio.717e3a98.jpg";